// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "* {\n\tpadding: 0;\n\tmargin: 0;\n}\n\nbody,\nhtml {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\toverflow: hidden;\n}\n\n.canvas {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n}\n\n.canvas.has-cursor-grab {\n\tcursor: grab;\n}\n\n.canvas.has-cursor-grabbing {\n\tcursor: grabbing;\n}\n\n.canvas.has-cursor-pointer {\n\tcursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
